import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.4_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.13.1_@upstash+red_1394b70abd98536012376ec3d35499b7/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}